/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetPaymentStatus200ResponseData } from './GetPaymentStatus200ResponseData'
import {
  GetPaymentStatus200ResponseDataFromJSON,
  GetPaymentStatus200ResponseDataFromJSONTyped,
  GetPaymentStatus200ResponseDataToJSON,
} from './GetPaymentStatus200ResponseData'

/**
 *
 * @export
 * @interface GetPaymentStatus200Response
 */
export interface GetPaymentStatus200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetPaymentStatus200Response
   */
  status: boolean
  /**
   *
   * @type {GetPaymentStatus200ResponseData}
   * @memberof GetPaymentStatus200Response
   */
  data: GetPaymentStatus200ResponseData
}

/**
 * Check if a given object implements the GetPaymentStatus200Response interface.
 */
export function instanceOfGetPaymentStatus200Response(
  value: object
): value is GetPaymentStatus200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetPaymentStatus200ResponseFromJSON(
  json: any
): GetPaymentStatus200Response {
  return GetPaymentStatus200ResponseFromJSONTyped(json, false)
}

export function GetPaymentStatus200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetPaymentStatus200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: GetPaymentStatus200ResponseDataFromJSON(json['data']),
  }
}

export function GetPaymentStatus200ResponseToJSON(
  value?: GetPaymentStatus200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: GetPaymentStatus200ResponseDataToJSON(value['data']),
  }
}
